module.exports = __webpack_public_path__ + "img/Le-District-Website-Logo-768x682.3b027196.png";